import React from 'react';
import { useTheme } from '../context/ThemeContext';

const ThemeToggle: React.FC = () => {
    const { theme, toggleTheme } = useTheme();

    return (
        <button
            onClick={toggleTheme}
            className="relative w-14 h-14 rounded-full flex items-center justify-center transition-all duration-300 hover:scale-110 focus:outline-none group"
            aria-label={`Switch to ${theme === 'light' ? 'dark' : 'light'} mode`}
            style={{
                background: theme === 'light'
                    ? 'linear-gradient(135deg, #3F45FF 0%, #5721C6 100%)'
                    : 'linear-gradient(135deg, #3F45FF 0%, #5721C6 100%)',
                boxShadow: theme === 'light'
                    ? '0 0 20px rgba(63, 69, 255, 0.3)'
                    : '0 0 20px rgba(63, 69, 255, 0.5)'
            }}
        >
            {/* Sun Icon (Light Mode) */}
            <svg
                className={`absolute w-6 h-6 transition-all duration-500 ${theme === 'light'
                        ? 'opacity-100 rotate-0 scale-100'
                        : 'opacity-0 rotate-180 scale-0'
                    }`}
                fill="none"
                stroke="white"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M12 3v1m0 16v1m9-9h-1M4 12H3m15.364 6.364l-.707-.707M6.343 6.343l-.707-.707m12.728 0l-.707.707M6.343 17.657l-.707.707M16 12a4 4 0 11-8 0 4 4 0 018 0z"
                />
            </svg>

            {/* Moon Icon (Dark Mode) */}
            <svg
                className={`absolute w-6 h-6 transition-all duration-500 ${theme === 'dark'
                        ? 'opacity-100 rotate-0 scale-100'
                        : 'opacity-0 -rotate-180 scale-0'
                    }`}
                fill="none"
                stroke="white"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M20.354 15.354A9 9 0 018.646 3.646 9.003 9.003 0 0012 21a9.003 9.003 0 008.354-5.646z"
                />
            </svg>

            {/* Glow effect on hover */}
            <div
                className="absolute inset-0 rounded-full opacity-0 group-hover:opacity-100 transition-opacity duration-300"
                style={{
                    boxShadow: '0 0 30px rgba(63, 69, 255, 0.6), 0 0 60px rgba(87, 33, 198, 0.4)'
                }}
            />
        </button>
    );
};

export default ThemeToggle;
